import { SegmentStatus } from '@/models/SegmentStatus';
import { TEXT_MAX_LENGTH } from '@/utils/constants';

export function calculateSegmentStatus(sourceText: string, targetText: string): SegmentStatus {
    const sourceOver = sourceText.trim().length >= TEXT_MAX_LENGTH;
    const targetOver = targetText.trim().length >= TEXT_MAX_LENGTH;

    if (sourceOver && targetOver) return SegmentStatus.SourceAndTargetReach500Limit;
    if (targetOver) return SegmentStatus.TargetReach500Limit;
    if (sourceOver) return SegmentStatus.SourceReach500Limit;
    return SegmentStatus.Ok;
}
